import React from "react";
import NoDataState from "../../../RnRCommonComponent/noDataState/NoDataState.jsx";
import { addCommas } from "../../../rewardsAndRecognitionHelper/utils.js";
import { useSelector } from "react-redux";

const RewardsLeaderBoard = (props) => {
  const { leaderboardData, selectedFilter, setSelectedFilter } = props;
  const currentUser = useSelector(state => state?.user?.currentUser);
  const subCompanyLabel = currentUser?.company?.subCompanyLabel || 'SubCompany';
	const departmentLabel = currentUser?.company?.labelDepartment || 'Department';

  const filterOptions = [
    { key: 'all', label: 'All' },
    { key: 'subcompany', label: `My ${subCompanyLabel}` },
    { key: 'department', label: `My ${departmentLabel}` }
  ];

  return <div className='reward-leaderboard-card'>
    <div className='d-flex justify-content-between align-items-center mb-3'>
      <h4 className='reward-leaderboard-card-title'>
        Recognition Leaderboard
      </h4>
    </div>
    <div className='d-flex flex-wrap mb-3' style={{ gap: '16px' }}>
      {filterOptions.map((option, index) => (
        <React.Fragment key={option.key}>
          <span
            onClick={() => setSelectedFilter(option.key)}
            style={{
              fontSize: '14px',
              fontWeight: selectedFilter === option.key ? 'bold' : 'normal',
              color: selectedFilter === option.key ? '#1890ff' : '#666',
              cursor: 'pointer',
              userSelect: 'none'
            }}
          >
            {option.label}
          </span>
          {index < filterOptions.length - 1 && (
            <span style={{ color: '#ccc', fontSize: '14px' }}>|</span>
          )}
        </React.Fragment>
      ))}
    </div>
    {leaderboardData?.length > 0 ? leaderboardData?.map((data, index) => {
      return <div key={index} className='reward-leaderboard-list d-flex justify-content-between align-items-center py-1'>
        <div className='reward-leaderboard-list-name d-flex align-items-center'>
          <div className={data.isCurrent ? 'pr-1 text-blue' : 'pr-1'}>{data?.rank}.</div>
          <div className={data.isCurrent ? 'pr-1 text-blue' : 'pr-1'}>{data?.firstName} {data?.lastName}</div>
        </div>
        <div className={data.isCurrent ? 'reward-leaderboard-list-points-blue' : 'reward-leaderboard-list-points'}>{addCommas(data?.points)}</div>
      </div>
    }) :
      <NoDataState title={"No leaders found yet."} />
    }
  </div >
};

export default RewardsLeaderBoard;
